import React from "react";
import {
  Autocomplete as MuiAutocomplete,
  type AutocompleteProps,
} from "@mui/material";
import FeatherIcon from "feather-icons-react";

type Autocomplete = <
  T,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
  ChipComponent extends React.ElementType = "div",
>(
  props: AutocompleteProps<
    T,
    Multiple,
    DisableClearable,
    FreeSolo,
    ChipComponent
  >,
) => JSX.Element;

const Autocomplete: Autocomplete = ({ popupIcon, ...props }) => (
  <MuiAutocomplete
    popupIcon={popupIcon ?? <FeatherIcon icon="chevron-down" size={24} />}
    {...props}
  />
);

export default Autocomplete;
